// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    FinancialScreeningRequest,
    FinancialScreeningRequestSearchRequest,
    FinancialScreeningResultSearchRequest,
    FinancialScreeningV1FinancialScreeningV1FinancialScreeningDefaultResponse,
    FinancialScreeningV1FinancialScreeningV1FinancialScreeningRequestSearchDefaultResponse,
    FinancialScreeningV1FinancialScreeningV1FinancialScreeningResultSearchDefaultResponse,
    GatewayError,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeFinancialScreeningApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param financialScreeningRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async financialScreeningV1FinancialScreening (financialScreeningRequest: FinancialScreeningRequest, xProgramId?: string): Promise<AxiosResponse<FinancialScreeningV1FinancialScreeningV1FinancialScreeningDefaultResponse>> {
        const _url_ = '/edge/financialScreening/v1/FinancialScreening';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'financialScreeningRequest' is not null or undefined
        if (financialScreeningRequest === null || financialScreeningRequest === undefined) {
            throw new Error('Required parameter financialScreeningRequest was null or undefined when calling financialScreeningV1FinancialScreening.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(financialScreeningRequest, "FinancialScreeningRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<FinancialScreeningV1FinancialScreeningV1FinancialScreeningDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "FinancialScreeningV1FinancialScreeningV1FinancialScreeningDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param financialScreeningRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async financialScreeningV1FinancialScreeningRequestSearch (financialScreeningRequestSearchRequest: FinancialScreeningRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<FinancialScreeningV1FinancialScreeningV1FinancialScreeningRequestSearchDefaultResponse>> {
        const _url_ = '/edge/financialScreening/v1/FinancialScreeningRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'financialScreeningRequestSearchRequest' is not null or undefined
        if (financialScreeningRequestSearchRequest === null || financialScreeningRequestSearchRequest === undefined) {
            throw new Error('Required parameter financialScreeningRequestSearchRequest was null or undefined when calling financialScreeningV1FinancialScreeningRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(financialScreeningRequestSearchRequest, "FinancialScreeningRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<FinancialScreeningV1FinancialScreeningV1FinancialScreeningRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "FinancialScreeningV1FinancialScreeningV1FinancialScreeningRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param financialScreeningResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async financialScreeningV1FinancialScreeningResultSearch (financialScreeningResultSearchRequest: FinancialScreeningResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<FinancialScreeningV1FinancialScreeningV1FinancialScreeningResultSearchDefaultResponse>> {
        const _url_ = '/edge/financialScreening/v1/FinancialScreeningResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'financialScreeningResultSearchRequest' is not null or undefined
        if (financialScreeningResultSearchRequest === null || financialScreeningResultSearchRequest === undefined) {
            throw new Error('Required parameter financialScreeningResultSearchRequest was null or undefined when calling financialScreeningV1FinancialScreeningResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(financialScreeningResultSearchRequest, "FinancialScreeningResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<FinancialScreeningV1FinancialScreeningV1FinancialScreeningResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "FinancialScreeningV1FinancialScreeningV1FinancialScreeningResultSearchDefaultResponse");
        }
        return response;
    }
}
